export const kubernetesResourceTypes = new Set([
  "kubernetes_node",
  "kubernetes_namespace",
  "kubernetes_deployment",
  "kubernetes_stateful_set",
  "kubernetes_daemon_set",
  "kubernetes_replica_set",
  "kubernetes_job",
  "kubernetes_pod",
]);
